module.exports = __webpack_public_path__ + "media/images/lp_cv-block-1-524521eabf88c7c7efbe16088e750a5e.webp";